<template>
	<h2>Métodos de pago</h2>
	<p class="text-general text-padding-left">
		Elige el método de pago que quieras utilizar
	</p>
	<!-- <div class="info-box-lg">
		<div class="custom-checkbox">
			<input type="radio" v-model="payment" value="1" id="cb-payment-1">
			<label for="cb-payment-1">
				Tarjeta de crédito o Débito
			</label>
		</div>
		<p class="text-general padding-side-left-md">
		Selecciona esta opción para pagos con tu Tarjeta de Credito o Debito Visa o Mastercard.
		<br>
		Te redirigiremos al Portal digital de Bancomer. Es 100% Seguro.
		</p>
	</div> -->
	<div class="info-box-lg">
		<div class="custom-checkbox">
			<input type="radio" v-model="payment" value="2" id="cb-payment-2">
			<label for="cb-payment-2">
				<img class="img-responsive" src="../../images/paypal.png" alt="fedex">
			</label>
		</div>
		<p class="text-general padding-side-left-md">
		Si tienes cuenta en Paypal puedes utilizarla para realizar tu pago. <br>
		Te redirigiremos al Portal de Paypal. Es 100% Seguro.
		</p>
	</div>

	<!-- DEPRECATED: fraud -->
	<!-- <div class="info-box-lg">
		<div class="custom-checkbox">
			<input type="radio" v-model="payment" value="6" id="cb-payment-6">
			<label for="cb-payment-6">
				<span>
					Tarjeta de débito o crédito (powered by
					<img class="img-responsive" src="../../images/paypal.png" alt="fedex">)
				</span>
			</label>
		</div>
		<p class="text-general padding-side-left-md">
		Realiza tu compra a traves de la pasarela de pago con tu tarjeta de débito/crédito.
		</p>
	</div> -->

	<div class="info-box-lg">
		<div class="custom-checkbox">
			<input type="radio" v-model="payment" value="3" id="cb-payment-3">
			<label class="info-box-title" for="cb-payment-3">Transferencia / Depósito Bancario
			</label>
		</div>
		<p class="text-general padding-side-left-md">
		Selecciona esta opción para realizar tu pago en el Banco o mediante Transferencia Electrónica.
		</p>
	</div>

	<!-- <div class="info-box-lg">
		<div class="custom-checkbox">
			<input type="radio" v-model="payment" value="4" id="cb-payment-3">
			<label class="info-box-title" for="cb-payment-3">
				<img class="img-responsive" src="../../images/mercado-pago.png" alt="mercadopago">
			</label>
		</div>
		<p class="text-general padding-side-left-md">
		Utiliza tu cuenta de Mercadopago y accede a varios métodos de pago disponibles. Con esta opción puedes pagar en OXXOs.  Te redirigiremos al Portal de MercadoPago. Es 100% Seguro.
		</p>
	</div> -->

	<!-- <div class="info-box-lg">
		<div class="custom-checkbox">
			<input type="radio" v-model="payment" value="5" id="cb-payment-4">
			<label class="info-box-title" for="cb-payment-4">
				Efectivo
			</label>
		</div>
		<p class="text-general padding-side-left-md">
		Selecciona esta opción para pagar en Efectivo en nuestro Showroom exclusivamente.<br>
		Una vez confirmtado tu pedido nos contactaremos contigo para agendar tu visita.
		</p>
	</div> -->

	<div v-if="has_error" class="error">Selecciona un metodo de pago.</div>
	<div class="col-sm-offset-9 col-sm-3 no-padding-sides"><br>
		<button type="submit" class="btn btn-black btn-lg" @click="nextStep">Continuar</button>
	</div>
</template>

<script>
import { setPaymentShoppingCart } from '../../store/actions';

export default {
	data() {
		return {
			payment: 0,
			has_error: false
		}
	},

	vuex: {
		getters: {
			allow_continue: state => state.allow_continue
		},
		actions: {
			setPaymentShoppingCart
		}
	},

	methods: {
		nextStep(e) {
			e.preventDefault();
			this.has_error = false;
			this.validations();

			if (this.has_error) {
				return;
			}

			this.setPaymentShoppingCart(this.payment);
			this.allow_continue[4] = true;
			$('#summary').tab('show');
		},

		validations() {
			if (!this.payment) {
				this.has_error = true;
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// Shopping-cart-payment.vue?24230596